<template>
  <div class="custom-field">
    <custom-field-label :field="field" />

    <v-autocomplete
      color="primary"
      variant="outlined"
      :required="field.required"
      v-model="field.value"
      :rules="validationRules"
      :items="field.dropDownValues"
      clearable
      :placeholder="field.description"
      open-on-clear
      :menu-props="{ maxHeight }"
      multiple></v-autocomplete>
  </div>
</template>

<script>
import customFieldTypeMixin from '@/components/custom_fields/mixins/customFieldTypeMixin';
import { isMobile } from '@/util';

export default {
  mixins: [customFieldTypeMixin],
  computed: {
    maxHeight() {
      return isMobile() ? 150 : 500;
    }
  }
};
</script>
